import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart3, CalendarDays, Target, Users } from "lucide-react";

const CARDS = [
  { key: "conversations_today", label: "Conversations aujourd'hui", icon: CalendarDays, testId: "stats-today-card" },
  { key: "conversations_week", label: "Conversations cette semaine", icon: BarChart3, testId: "stats-week-card" },
  { key: "qualified_leads", label: "Leads qualifiés", icon: Users, testId: "stats-leads-card" },
  { key: "qualification_rate", label: "Taux de qualification", icon: Target, suffix: " %", testId: "stats-rate-card" },
];

export default function StatsPage() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = () => api.get("/stats").then((res) => setStats(res.data)).catch(() => {});
    fetchStats();
    const interval = setInterval(fetchStats, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-full overflow-y-auto chat-scroll px-5 md:px-8 py-6" data-testid="stats-page">
      <h2 className="font-serif text-2xl">Statistiques</h2>
      <p className="text-sm text-muted-foreground mt-1 mb-6">Vue d'ensemble de l'activité de l'agent WhatsApp.</p>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {CARDS.map(({ key, label, icon: Icon, suffix, testId }) => (
          <div
            key={key}
            data-testid={testId}
            className="bg-card rounded-xl border border-border p-6 shadow-sm transition-transform duration-200 hover:-translate-y-0.5"
          >
            <div className="flex items-center justify-between">
              <p className="text-sm text-muted-foreground">{label}</p>
              <Icon className="h-4 w-4 text-primary" />
            </div>
            <p className="font-serif text-4xl mt-3">
              {stats ? `${stats[key]}${suffix || ""}` : "…"}
            </p>
          </div>
        ))}
      </div>

      {stats && (
        <p className="text-xs text-muted-foreground mt-6" data-testid="stats-total-note">
          {stats.total_conversations} conversation{stats.total_conversations > 1 ? "s" : ""} au total depuis le lancement de l'agent.
        </p>
      )}
    </div>
  );
}
